import ApiaField from '../ApiaField';
import ApiaForm from '../ApiaForm';
import { IApiaField } from '../types';

export type THiddenField = IApiaField;

export default class HiddenField extends ApiaField implements THiddenField {
  constructor(field: HTMLInputElement, form: ApiaForm) {
    super(field, form, []);
  }
}
